(() => {
  function init() {
    const root = document.getElementById('lm-brandbook');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const chatLink = root.querySelector('[data-lm-chat]');
    if (chatLink) {
      let stopWatching = null;
      chatLink.addEventListener('click', event => {
        const host = document.querySelector('shopify-chat');
        // Use the component's public show() method; retain email if unavailable.
        if (typeof host?.show !== 'function') return;
        event.preventDefault();
        event.stopPropagation();
        stopWatching?.();
        host.setAttribute('data-lm-open', '');
        chatLink.setAttribute('aria-expanded', 'true');
        let hasOpened = host.hasAttribute('open');
        const watch = new MutationObserver(() => {
          if (host.hasAttribute('open')) { hasOpened = true; return; }
          if (!hasOpened) return;
          host.removeAttribute('data-lm-open');
          chatLink.setAttribute('aria-expanded', 'false');
          watch.disconnect();
          stopWatching = null;
          chatLink.focus({ preventScroll: true });
        });
        stopWatching = () => watch.disconnect();
        watch.observe(host, { attributes: true, attributeFilter: ['open'] });
        host.show();
      });
    }
    const product = JSON.parse(root.querySelector('[data-product]').textContent);
    const details = JSON.parse(root.querySelector('[data-variant-details]').textContent);
    const words = JSON.parse(root.querySelector('[data-strings]').textContent);
    const prefixes = ['duo-brown-yellow-', 'duo-royalblue-lightgray-', 'duo-graygreen-brown-', 'duo-green-lightgray-'];
    const q = selector => root.querySelector(selector);
    const all = selector => [...root.querySelectorAll(selector)];
    const form = q('#lm-brandbook-form');
    const input = form.querySelector('[name="id"]');
    const button = q('.lm-cta');
    const status = q('.lm-status');
    const main = q('.lm-current-image');
    const modal = q('.lm-zoomed');
    const colourButtons = all('[data-colour]');
    let colour = 0, size = '', variant = null, busy = false, frames = [];
    const initial = product.variants.find(v => String(v.id) === new URL(location.href).searchParams.get('variant'));
    if (initial) { colour = colourButtons.findIndex(b => b.dataset.value === initial.options[0]); size = initial.options[1]; }
    if (colour < 0) colour = 0;
    const src = (url, width) => { const u = new URL(url, location.origin); u.searchParams.set('width', width); return u.href; };
    function frame(index) {
      const image = frames[index]; if (!image) return;
      main.src = src(image, 1200);
      main.srcset = [400,600,800,1200,1600].map(w => `${src(image,w)} ${w}w`).join(',');
      main.alt = `${product.title} — ${colourButtons[colour].dataset.value} — ${index + 1}`;
      q('.lm-count').textContent = `${index + 1} / ${frames.length}`;
      modal.querySelector('img').src = src(image, 2000);
      modal.querySelector('img').alt = main.alt;
      all('.lm-thumb').forEach((b,i) => b.setAttribute('aria-pressed',String(i===index)));
    }
    function gallery() {
      frames = product.images.filter(image => image.includes(prefixes[colour]));
      if (!frames.length) frames = [product.featured_image];
      q('.lm-thumbs').replaceChildren();
      frames.forEach((image,index) => {
        const b = document.createElement('button'); b.type='button'; b.className='lm-thumb';
        b.setAttribute('aria-label',`${colourButtons[colour].dataset.value} — ${index + 1}`);
        const im = document.createElement('img'); im.src=src(image,160); im.alt=''; im.width=60; im.height=75; im.loading='lazy'; b.append(im);
        b.addEventListener('click',()=>frame(index)); q('.lm-thumbs').append(b);
      });
      const detail = frames.find(image=>image.includes('04-detale'));
      if (detail) { const story=q('.lm-story-image'); story.src=src(detail,1000); story.srcset=[400,600,1000].map(w=>`${src(detail,w)} ${w}w`).join(','); story.alt=`${product.title} — ${colourButtons[colour].dataset.value}`; }
      frame(0);
    }
    function update(writeURL=true) {
      const colourName = colourButtons[colour].dataset.value;
      variant = product.variants.find(v=>v.options[0]===colourName && v.options[1]===size);
      const shown = variant || product.variants.find(v=>v.options[0]===colourName);
      const info = details.find(v=>v.id===shown?.id);
      colourButtons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===colour)));
      q('.lm-colour-name').textContent=colourName;
      all('[data-size]').forEach(b=>{
        const v=product.variants.find(v=>v.options[0]===colourName && v.options[1]===b.dataset.size);
        b.disabled=!v?.available; b.setAttribute('aria-pressed',String(b.dataset.size===size));
      });
      if (size) q('.lm-size-name').textContent=size;
      q('[data-price]').textContent=info?.price||'';
      q('[data-compare]').hidden=!(shown?.compare_at_price>shown?.price);
      q('[data-compare]').textContent=info?.compare||'';
      input.value=variant?.id||''; input.disabled=!variant?.available;
      button.disabled=busy || Boolean(size && !variant?.available);
      button.textContent=busy?words.adding:!size?words.choose:!variant?.available?words.sold_out:`${words.add} · ${info.price}`;
      status.removeAttribute('role');
      status.textContent=!size?words.choose_hint:!variant?.available?words.unavailable:`${words.selected} ${colourName}, ${size}.`;
      const length={S:117,M:118,L:119,XL:120}[size]; if(length)q('.lm-length').textContent=`${words.length} ${length} cm.`;
      q('.lm-stock').textContent=variant?.available?(info.managed&&info.inventory<=0?words.backorder:words.in_stock):'';
      if(writeURL){const u=new URL(location.href);if(variant)u.searchParams.set('variant',variant.id);else u.searchParams.delete('variant');history.replaceState({},'',u);}
    }
    colourButtons.forEach((b,i)=>b.addEventListener('click',()=>{colour=i;gallery();update();q('.lm-cart-result').hidden=true;}));
    all('[data-size]').forEach(b=>b.addEventListener('click',()=>{size=b.dataset.size;update();q('.lm-cart-result').hidden=true;}));
    form.addEventListener('submit',async event=>{
      event.preventDefault(); if(busy)return;
      if(!size){status.textContent=words.error;status.setAttribute('role','alert');all('[data-size]').find(b=>!b.disabled)?.focus();return;}
      if(!variant?.available)return;
      const selectedId=variant.id; busy=true; update(false);
      try{
        const endpoint=new URL(form.action);endpoint.pathname=endpoint.pathname.replace(/\/add\/?$/,'/add.js');
        const sections=['variant-added'];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections}}));
        const response=await fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:selectedId,quantity:1}],sections:[...new Set(sections)],sections_url:`${window.Shopify?.routes?.root || '/'}variants/${selectedId}`}),credentials:'same-origin'});
        const data=await response.json();if(!response.ok)throw new Error(data.description||words.failure);
        try {
          const cartUrl=new URL(form.action);cartUrl.pathname=cartUrl.pathname.replace(/\/add\/?$/,'.js');
          const cartResponse=await fetch(cartUrl,{headers:{Accept:'application/json'},credentials:'same-origin'});
          if(!cartResponse.ok)throw new Error('cart sync');
          const cart=await cartResponse.json();cart.sections=data.sections;
          if(!cart.sections || Object.values(cart.sections).some(value=>value===null))throw new Error('section sync');
          form.dispatchEvent(new CustomEvent('variant:add',{bubbles:true,detail:{items:data.items||[data],cart}}));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',cart}}));
        } catch(syncError) { document.dispatchEvent(new CustomEvent('cart:refresh')); }
        const result=q('.lm-cart-result');result.replaceChildren(document.createTextNode(words.success+' '));
        const a=document.createElement('a');a.href=form.action.replace(/\/add\/?$/,'');a.textContent=words.cart;result.append(a);result.hidden=false;
      }catch(error){status.textContent=error.message||words.failure;status.setAttribute('role','alert');}
      finally{busy=false;button.disabled=!variant?.available;button.textContent=variant?.available?`${words.add} · ${details.find(v=>v.id===variant.id).price}`:words.sold_out;}
    });
    const guide=q('.lm-size-guide'),trigger=q('.lm-guide-trigger');
    trigger.addEventListener('click',()=>{guide.hidden=!guide.hidden;trigger.setAttribute('aria-expanded',String(!guide.hidden));});
    q('.lm-guide-close').addEventListener('click',()=>{guide.hidden=true;trigger.setAttribute('aria-expanded','false');trigger.focus();});
    q('.lm-zoom').addEventListener('click',()=>modal.showModal());
    q('.lm-close-zoom').addEventListener('click',()=>modal.close());
    modal.addEventListener('close',()=>q('.lm-zoom').focus());
    gallery();update(false);
  }
  init();document.addEventListener('shopify:section:load',init);
})();
